import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { RequestDevicesService } from "../../../services/request-devices.service";
import { RequestsService } from "../../../services/requests.service";
import { NewRequestDevice } from "../../../models/request/new-request/new-request-device";
import { NewRequestService } from "../../../models/request/new-request/new-request-service";
import { GridComponent } from "@progress/kendo-angular-grid";
import { LookupService } from "../../../services/lookup.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { DeviceStatus, RequestType } from "../../../enums";
import { ReserveResult } from "../../../enums/reserve-result.enum";
import { DeviceModelDto } from "../../../models/device/device-model-dto";
import { DeviceModelsService } from "../../../services/device-models.service";
import { CustomerObjectsService } from "../../../../categories/customer-objects/customer-objects.service";
import { CustomerObjectDeviceDto } from "../../../models/customerObject/customer-object-device";
import { RequestBwt } from "../../../models/request/request-bwt";
import { DeviceTypesService } from "../../../services/device-types.service";
import { DeviceTypeDto } from "../../../models/device/device-type.dto";
import { SecurityService } from "../../../../core/services/security.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { NotificationType } from "../../../../core/services/notification-type";
import { SetRequestDevicesDiscount, SetRequestDevicesDiscountItem } from "../../../models/discount/set-request-devices-discount";
import { SetRequestServicesDiscount, SetRequestServicesDiscountItem } from "../../../models/discount/set-request-services-discount";
import { DiscountLevelsService } from "../../../services/discount-levels.service";
import { DevicesHierarchicalSelectorComponent } from "../../devices-hierarchical-selector/devices-hierarchical-selector.component";
import { ServicesHierarchicalSelectorComponent } from "../../services-hierarchical-selector/services-hierarchical-selector.component";
import { DialogService } from "@progress/kendo-angular-dialog";
import { ContragentsService } from "../../../../categories/contragents/contragents.service";
import { RequestTypeService } from "../../../services/request-type.service";
import { DevicesService } from "../../../services/devices.service";
import { ReclamationDevicesService } from "../../../services/reclamation-devices.service";
import { AppService } from "../../../../app.service";
import { CachesService } from "../../../services/caches.service";
import { PaymentStatusEnum } from "../../../enums/payment-status.enum";
import { PaymentTypeEnum } from "../../../enums/payment-type.enum";
import { PaymentsService } from "../../../services/payments-service";
import { RequestPaymentItem } from "../../../models/payonline/request-payment-item";
import { RequestServicesService } from "../../../services/request-services.service";
import { CategoryServicesService } from "../../../services/category-services.service";
import { ServiceItem } from "../../../models/services/service-item";
import { MultipleRequestServiceItem, MultipleRequestServices } from "../../../models/request/multiple-request-services";
import { RequestPageAgreementServicesComponent } from "../request-page-agreement-services/request-page-agreement-services.component";

@Component({
    selector: 'request-page-services-and-devices',
    templateUrl: './request-page-services-and-devices.component.html',
    styleUrls: ['./request-page-services-and-devices.component.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
    ],
    encapsulation: ViewEncapsulation.None,
})
export class RequestPageServicesAndDevicesComponent implements OnInit {

    @ViewChild("requestDevicesGrid") requestDevicesGrid: GridComponent;
    @ViewChild("requestServicesGrid") requestServicesGrid: GridComponent;
    @ViewChild("customerObjectDevicesGrid") customerObjectDevicesGrid: GridComponent;
    @ViewChild("agreementServices") agreementServices: RequestPageAgreementServicesComponent;

    @Input() requestId: number;
    @Input() requestTypeId: number;
    @Input() requestCategoryId: number;
    @Input() customerContragentId: number;
    @Input() reclamationDeviceId: number;
    @Input() paymentStatusId: number;
    @Input() paymentStatusName: string;
    @Input() paymentStatusColor: string;
    @Input() paymentTypeId: number;
    @Input() canEditRequest: boolean = true;
    @Input() showServices: boolean = true;
    @Input() showDevices: boolean = true;
    @Input() isServiceAgreement: boolean = false;
    @Input() skipInventory: boolean = false;

    @Output() refreshRequestEvent: EventEmitter<RequestBwt> = new EventEmitter<RequestBwt>();
    @Output() refreshRequestDeviceModelsEvent: EventEmitter<any> = new EventEmitter<any>();

    loadingDevices: boolean = false;
    loadingServices: boolean = false;
    dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };
    otherObjectDevicesExpanded: boolean = false;
    editingCustomerDeviceId: number = null;
    editingCustomerSerial: string = '';
    private paidDeviceIds = new Set<number>();
    private paidServiceIds = new Set<number>();

    roleForceDiscount: boolean;
    roleDiscountLimit: number;
    maxDiscountLimit: number;

    allRequestDevices: NewRequestDevice[] = [];
    mainRequestDevices: NewRequestDevice[] = [];
    additionalRequestDevices: NewRequestDevice[] = [];
    customerObjectDevices: CustomerObjectDeviceDto[] = [];

    fullService: ServiceItem[] = [];
    services: KeyValueObject[] = [];
    requestServices: NewRequestService[] = [];

    deviceTypeFullItems: DeviceTypeDto[] = [];
    deviceTypes: KeyValueObject[] = [];
    deviceModels: DeviceModelDto[] = [];
    dropDownDeviceModels: DeviceModelDto[] = [];
    deviceSuppliers: DeviceModelDto[] = [];
    dropDownDeviceSuppliers: DeviceModelDto[] = [];
    marketPlaces: KeyValueObject[] = [];
    warrantyRequestTypes: number[] = [];
    installTypes: KeyValueObject[] = [];
    costCenters: KeyValueObject[] = [];

    contragentPaymentTypeId: number;

    constructor(
        private appService: AppService,
        private deviceTypesService: DeviceTypesService,
        private lookupService: LookupService,
        private requestsService: RequestsService,
        public deviceModelsService: DeviceModelsService,
        private requestDevicesService: RequestDevicesService,
        private customerObjectsService: CustomerObjectsService,
        private securityService: SecurityService,
        private notificationService: NotificationService,
        private discountLevelsService: DiscountLevelsService,
        private dialogService: DialogService,
        private contragentsService: ContragentsService,
        private requestTypesService: RequestTypeService,
        private devicesService: DevicesService,
        private reclamationDevicesService: ReclamationDevicesService,
        private cachesService: CachesService,
        private requestServicesService: RequestServicesService,
        private categoryServicesService: CategoryServicesService,
        private paymentsService: PaymentsService
    ) { }

    ngOnInit(): void {
        this.roleDiscountLimit = this.securityService.currentUser.discountLimit;
        this.roleForceDiscount = this.securityService.currentUser.forceDiscount;
        this.loadLinePayments();

        if (this.showDevices) {
            this.loadRequestDevices();
        } else {
            this.loadCustomerObjectDevices();
        }

        if (this.showServices && !this.isServiceAgreement) {
            this.loadRequestServices();
        }

        const lookups: any[] = [
            this.lookupService.getData('cost-centers', null),
            this.contragentsService.getContragentWithContact(this.customerContragentId)
        ];

        if (this.showDevices) {
            lookups.push(this.deviceTypesService.getAllDeviceTypesNoCategory());
            lookups.push(this.deviceModelsService.getAll());
            lookups.push(this.lookupService.getData('device-market-places', null));
            lookups.push(this.requestTypesService.getWarrantyRequestTypes());
            lookups.push(this.lookupService.getData('device-install-types', null));
        }

        if (this.showServices && !this.isServiceAgreement) {
            lookups.push(this.categoryServicesService.list());
        }

        forkJoin(lookups).subscribe((results: any[]) => {
            let index = 0;
            this.costCenters = results[index++];
            const contragent = results[index++];
            if (contragent) {
                this.contragentPaymentTypeId = contragent.paymentTypeId;
            }

            if (this.showDevices) {
                this.deviceTypeFullItems = results[index++];
                this.deviceTypes = this.deviceTypeFullItems.map(x => new KeyValueObject(x.deviceTypeId, x.name));
                this.deviceModels = results[index++];
                this.dropDownDeviceModels = this.deviceModels;
                this.deviceSuppliers = this.deviceModels.filter(x => x.parentId == null);
                this.dropDownDeviceSuppliers = this.deviceSuppliers;
                this.marketPlaces = results[index++];
                this.warrantyRequestTypes = results[index++];
                this.installTypes = results[index++];
            }

            if (this.showServices && !this.isServiceAgreement) {
                const servicesResp = results[index++];
                this.fullService = servicesResp.data;
                this.services = servicesResp.data.map(x => new KeyValueObject(x.id, x.name));
            }
        });
    }

    loadRequestDevices() {
        this.loadingDevices = true;

        const requestDevices$ = this.requestsService.getRequestDevices(this.requestId);
        const requestCustomerObjectDevices$ = this.customerObjectsService.getRequestCustomerObjectDevices(this.requestId);

        forkJoin(requestDevices$, requestCustomerObjectDevices$)
            .subscribe(([requestDevices, requestCustomerObjectDevices]) => {
                requestDevices.forEach(x => x.discountPrimary = x.discount);
                this.allRequestDevices = requestDevices;
                this.mainRequestDevices = this.isReclamation
                    ? requestDevices.filter(x => x.manuallyAdded == false && !x.inClaim)
                    : requestDevices.filter(x => x.manuallyAdded == false);
                this.mainRequestDevices = this.groupDevices(this.mainRequestDevices);
                this.additionalRequestDevices = requestDevices.filter(x => x.manuallyAdded == true);
                this.additionalRequestDevices = this.groupDevices(this.additionalRequestDevices);
                this.applyCustomerObjectDevices(requestCustomerObjectDevices);
                this.refreshRequestDeviceModelsEvent.emit();
                this.loadingDevices = false;
                this.autoFitGrids();
            }, () => this.loadingDevices = false);
    }

    loadCustomerObjectDevices() {
        this.customerObjectsService.getRequestCustomerObjectDevices(this.requestId).subscribe((resp) => {
            this.applyCustomerObjectDevices(resp);
        });
    }

    applyCustomerObjectDevices(devices: CustomerObjectDeviceDto[]) {
        this.customerObjectDevices = devices || [];
        this.customerObjectDevices.forEach(x => {
            x.manufactureDate = this.appService.parseDate(x.manufactureDate);
            x.lastRequestDate = this.appService.parseDate(x.lastRequestDate);
            x.installationDate = this.appService.parseDate(x.installationDate);
            x.lastServiceDate = this.appService.parseDate(x.lastServiceDate);
        });
    }

    loadRequestServices() {
        this.loadingServices = true;
        this.requestsService.getRequestServices(this.requestId).subscribe(resp => {
            resp.forEach(x => x.discountPrimary = x.discount);
            this.requestServices = this.groupServices(resp);
            this.loadingServices = false;
            this.autoFitGrids();
        }, () => this.loadingServices = false);
    }

    groupDevices = (devices: NewRequestDevice[]) => {
        return this.groupOwnDevices((devices || []).filter(item => !item.customerDevice));
    }

    groupOwnDevices = (devices: NewRequestDevice[]) => {
        return Object.values(
            devices.reduce((acc, item) => {
                const key = this.getGroupKey(item);
                if (!acc[key]) acc[key] = { ...item, requestDeviceIds: [], quantity: 0 };
                acc[key].requestDeviceIds.push(item.requestDeviceId);
                acc[key].quantity += item.quantity;
                return acc;
            }, {} as NewRequestDevice));
    }

    getGroupKey = (item: NewRequestDevice) =>
        `${item.deviceModelId}-${item.availableInCentralWarehouses}-${item.reserveResultId}-${item.isCompletelyAvailable}-${item.manuallyAdded}-${item.customerDevice}-${item.isPrepaid}`;

    groupServices = (items: NewRequestService[]) => {
        return Object.values(
            items.reduce((acc, item) => {
                const key = `${item.serviceId}-${item.isDefault}-${item.isPrepaidService}`;
                if (!acc[key]) acc[key] = { ...item, requestServiceIds: [], count: 0 };
                acc[key].requestServiceIds.push(item.requestServiceId);
                acc[key].count += item.count;
                return acc;
            }, {} as NewRequestService));
    }

    getNameById(items: KeyValueObject[] = [], id: number): string {
        return items.some(x => x.id == id)
            ? items.find(x => x.id == id).name
            : '';
    }

    createNewMainRequestDevice = (): NewRequestDevice => {
        let requestDevice = new NewRequestDevice;
        requestDevice.requestId = this.requestId;
        requestDevice.manuallyAdded = this.addAsAdditionalByDefault;
        requestDevice.customerDevice = this.skipInventory;
        requestDevice.cost = 0;
        requestDevice.fullCost = 0;
        requestDevice.requestDeviceId = 0;

        if (this.isReclamation || this.skipInventory) {
            requestDevice.reserveResultId = <number>ReserveResult.installedOnTsp;
            requestDevice.inClaim = this.isReclamation;
            requestDevice.customerDevice = true;
        }
        else {
            requestDevice.reserveResultId = <number>ReserveResult.notBooked;
        }

        this.maxDiscountLimit = 0;

        return requestDevice;
    }

    addNewCustomerRequestDevice() {
        this.requestDevicesGrid.addRow(this.createNewMainRequestDevice());
    }

    addCustomerEquipment() {
        const dialogRef = this.dialogService.open({
            content: DevicesHierarchicalSelectorComponent,
            title: 'Добавить оборудование клиента',
            width: '80%',
            height: '870px',
            minWidth: '800px'
        });
        const devicesSelector = <DevicesHierarchicalSelectorComponent>dialogRef.content.instance;

        devicesSelector.height = 500;
        devicesSelector.defaultRequestCategoryId = this.requestCategoryId;
        devicesSelector.disableFreeItems = false;
        devicesSelector.requestId = this.requestId;
        devicesSelector.isReclamation = false;
        devicesSelector.hideWarehouses = true;
        devicesSelector.showAddAsAdditional = false;
        devicesSelector.addAsAdditional = false;

        devicesSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        devicesSelector.onContinue.subscribe((requestDevices: NewRequestDevice[]) => {
            dialogRef.close();
            this.otherObjectDevicesExpanded = true;
            this.loadingDevices = true;

            const result: NewRequestDevice[] = [];
            for (const requestDevice of requestDevices) {
                const quantity = requestDevice.quantity > 0 ? requestDevice.quantity : 1;
                for (let i = 0; i < quantity; i++) {
                    result.push({
                        ...requestDevice,
                        requestId: this.requestId,
                        quantity: 1,
                        manuallyAdded: false,
                        inClaim: false,
                        customerDevice: true,
                        isFromClientButton: true,
                        warehouseIntegraCode: null,
                        reserveResultId: <number>ReserveResult.equipmentPurchasedByEngineer
                    });
                }
            }

            this.createRequestDevicesMultiple(result);
        });
    }

    addNewRequestDevice() {
        if (this.skipInventory) {
            this.addNewCustomerRequestDevice();
            return;
        }
        const dialogRef = this.dialogService.open({
            content: DevicesHierarchicalSelectorComponent,
            title: 'Добавление оборудования',
            width: '80%',
            height: '870px',
            minWidth: '800px'
        });
        const devicesSelector = <DevicesHierarchicalSelectorComponent>dialogRef.content.instance;

        devicesSelector.height = 500;
        devicesSelector.defaultRequestCategoryId = this.requestCategoryId;
        devicesSelector.disableFreeItems = !this.isWarrantyRequest;
        devicesSelector.requestId = this.requestId;
        devicesSelector.isReclamation = false;
        devicesSelector.showAddAsAdditional = !this.addAsAdditionalByDefault;
        devicesSelector.addAsAdditional = this.addAsAdditionalByDefault;

        devicesSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        devicesSelector.onContinue.subscribe((requestDevices: NewRequestDevice[]) => {
            const manuallyAdded = this.addAsAdditionalByDefault || devicesSelector.addAsAdditional;
            this.maxDiscountLimit = 0;
            dialogRef.close();

            this.loadingDevices = true;
            requestDevices.forEach(requestDevice => {
                requestDevice.requestId = this.requestId;
                requestDevice.manuallyAdded = manuallyAdded;
                requestDevice.inClaim = false;
                requestDevice.customerDevice = false;
                requestDevice.reserveResultId = <number>ReserveResult.notBooked;
            });

            const result: NewRequestDevice[] = [];
            for (const requestDevice of requestDevices) {
                for (let i = 0; i < requestDevice.quantity; i++) {
                    result.push({ ...requestDevice, quantity: 1 });
                }
            }

            this.createRequestDevicesMultiple(result);
        });
    }

    createRequestDevicesMultiple(requestDevices: NewRequestDevice[] = []) {
        if (requestDevices.length == 0) {
            this.loadingDevices = false;
            return;
        }

        this.loadingDevices = true;
        const createRequestDevices$ = requestDevices.map(requestDevice => {
            return this.requestDevicesService.create(requestDevice);
        });

        forkJoin(createRequestDevices$).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    saveRequestDeviceHandler({ dataItem }: any) {
        this.loadingDevices = true;
        let isNew = dataItem.requestDeviceId == null || dataItem.requestDeviceId == 0 || dataItem.requestDeviceIds.length == 0;

        if ((isNew && dataItem.customerDevice == true) ||
            (!isNew && dataItem.customerDevice == true && dataItem.reserveResultId == <number>ReserveResult.notBooked)) {
            dataItem.reserveResultId = <number>ReserveResult.equipmentPurchasedByEngineer;
        }
        else if ((isNew && dataItem.customerDevice != true) ||
            (!isNew && dataItem.customerDevice != true && dataItem.reserveResultId == <number>ReserveResult.equipmentPurchasedByEngineer)) {
            dataItem.reserveResultId = <number>ReserveResult.notBooked;
        }

        if (dataItem.reserveResultId == null) {
            dataItem.reserveResultId = <number>ReserveResult.notBooked;
        }

        dataItem.quantity = dataItem.quantity == null ? 1 : dataItem.quantity;

        let requestDeviceIds = dataItem.requestDeviceIds.filter(x => x != 0 && x != null);
        const requests$ = [];

        if (dataItem.quantity < requestDeviceIds.length) {
            const removeCount = requestDeviceIds.length - dataItem.quantity;
            const idsToRemove = requestDeviceIds.sort((a, b) => b - a).slice(0, removeCount);
            requestDeviceIds = requestDeviceIds.filter(x => !idsToRemove.includes(x));
            const removes$ = idsToRemove.map(requestDeviceId =>
                this.requestDevicesService.remove(requestDeviceId.toString(), null, null, true));
            requests$.push(...removes$);
        }

        if (dataItem.quantity > requestDeviceIds.length) {
            const createCount = dataItem.quantity - requestDeviceIds.length;
            const creates$ = Array.from({ length: createCount }, (_, i) => i).map(_ =>
                this.requestDevicesService.create({
                    ...dataItem,
                    requestId: this.requestId,
                    requestDeviceId: 0
                }, null));
            requests$.push(...creates$);
        }

        if (requestDeviceIds.length > 0) {
            const updates$ = requestDeviceIds.map(requestDeviceId =>
                this.requestDevicesService.update({
                    ...dataItem,
                    requestDeviceId: requestDeviceId
                }, null));
            requests$.push(...updates$);
        }

        forkJoin(requests$).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    removeRequestDeviceHandler({ dataItem }: any) {
        this.loadingDevices = true;
        const requestDeviceIds = dataItem.requestDeviceIds.filter(x => x != 0 && x != null);
        const removes$ = requestDeviceIds.map(requestDeviceId =>
            this.requestDevicesService.remove(requestDeviceId.toString(), null, null, true));
        forkJoin(removes$).subscribe(() => {
            this.loadRequestDevices();
            this.refreshRequest();
            this.refreshDeviceDropdowns();
        });
    }

    changeRequestCustomerDevice(event: any, requestDevice: NewRequestDevice) {
        if (event.target.checked) {
            requestDevice.costCenterId = null;
            requestDevice.costCenterName = null;
        }
    }

    public deviceTypeChange(deviceTypeId: number, requestDevice: NewRequestDevice | CustomerObjectDeviceDto = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
            requestDevice.deviceSupplierId = null;
        }

        this.calculateMaxDeviceDiscountLimit(requestDevice);
    }

    public deviceSupplierChange(supplierId: number, requestDevice: NewRequestDevice | CustomerObjectDeviceDto = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
        }
    }

    public cellClickRequestDeviceHandler({ sender, rowIndex, dataItem, isEdited }) {
        if (!this.canEditRequest || isEdited || !this.canEditDeviceRow(dataItem)) {
            return;
        }
        if (sender.isRowEdited && sender.isRowEdited(rowIndex)) {
            return;
        }

        this.editRequestDeviceHandler({ sender, rowIndex, dataItem });
    }

    public editRequestDeviceHandler({ sender, rowIndex, dataItem }) {
        this.handleDeviceSuppliersDropdownOpen(dataItem.deviceTypeId);
        this.handleDeviceModelsDropdownOpen(dataItem.deviceSupplierId);
        this.calculateMaxDeviceDiscountLimit(dataItem);

        if (dataItem.manufactureDate) {
            dataItem.manufactureDate = new Date(dataItem.manufactureDate);
        }

        sender.editRow(rowIndex);
    }

    public handleDeviceSuppliersDropdownOpen(deviceTypeId: number) {
        this.dropDownDeviceSuppliers = this.deviceModels != null && deviceTypeId
            ? this.deviceSuppliers.filter(x => x.typeId == deviceTypeId)
            : [];
    }

    public handleDeviceModelsDropdownOpen(deviceSupplierId: number) {
        this.dropDownDeviceModels = this.deviceModels != null && deviceSupplierId
            ? this.deviceModels.filter(x => x.parentId === deviceSupplierId)
            : [];
    }

    public checkCustomerObjectReclamationDevice(event: any, dataItem: CustomerObjectDeviceDto) {
        this.loadingDevices = true;
        if (event.target.checked) {
            if (this.reclamationDeviceId == null) {
                this.requestDevicesService.createFromDevice(this.requestId, dataItem.deviceId).subscribe((resp) => {
                    this.reclamationDeviceId = resp.data.reclamationDeviceId;
                    this.reclamationDevicesService.updateReclamationRequestDevice(this.requestId, resp.data.reclamationDeviceId).subscribe(() => {
                        this.loadRequestDevices();
                        this.refreshRequest();
                    });
                });
            } else {
                this.notificationService.confirmation({
                    title: 'В заявке уже указано оборудование в рекламации. Заменить?',
                    confirmButtonText: "Заменить",
                    cancelButtonText: "Нет"
                }, () => {
                    this.requestDevicesService.createFromDevice(this.requestId, dataItem.deviceId).subscribe((resp) => {
                        this.reclamationDeviceId = resp.data.reclamationDeviceId;
                        this.reclamationDevicesService.updateReclamationRequestDevice(this.requestId, resp.data.reclamationDeviceId).subscribe(() => {
                            this.loadRequestDevices();
                            this.refreshRequest();
                        });
                    });
                }, () => {
                    this.loadRequestDevices();
                    this.refreshRequest();
                });
            }
        }
        else {
            this.reclamationDeviceId = null;
            this.requestDevicesService.deleteFromDevice(this.requestId, dataItem.deviceId).subscribe(() => {
                this.loadRequestDevices();
                this.refreshRequest();
            });
        }
    }

    refreshRequest() {
        this.requestsService.getBwtById(this.requestId).subscribe(resp => {
            this.refreshRequestEvent.emit(resp.entity);
        });
    }

    requestDeviceNotReserved(dataItem: NewRequestDevice): boolean {
        return dataItem == null || dataItem.deviceStatusId != DeviceStatus.reserved;
    }

    canEditDeviceRow(dataItem: NewRequestDevice): boolean {
        if (dataItem && dataItem.customerDevice) {
            return this.isPurifierDevice(dataItem);
        }

        return this.requestDeviceNotReserved(dataItem);
    }

    isPurifierDevice(dataItem: NewRequestDevice): boolean {
        if (!dataItem) {
            return false;
        }

        if (dataItem.deviceTypeId === 68) {
            return true;
        }

        return (dataItem.deviceTypeName || '').toLowerCase().indexOf('пурифа') >= 0;
    }

    public canSaveRequestDevice(requestDevice: NewRequestDevice): boolean {
        const discountValid = !this.deviceDiscountInvalid(requestDevice);
        const costCenterValid = requestDevice.costCenterId != null || requestDevice.customerDevice;

        return (requestDevice.deviceTypeId != null &&
            requestDevice.deviceSupplierId != null &&
            requestDevice.deviceModelId != null &&
            costCenterValid &&
            discountValid) ||
            !this.isReclamation && (requestDevice.customerDevice == true &&
                discountValid)
            ||
            this.isReclamation && requestDevice.deviceTypeId != null &&
            requestDevice.deviceSupplierId != null &&
            requestDevice.deviceModelId != null &&
            discountValid &&
            requestDevice.quantity >= 1;
    }

    public canSaveCustomerObjectDevice(device: CustomerObjectDeviceDto): boolean {
        return device.deviceTypeId != null && device.deviceSupplierId != null && device.deviceModelId != null;
    }

    public rowClass() {
        return {
            'cursor-pointer': true
        };
    }

    getDeviceSum(requestDevice: NewRequestDevice): number {
        return requestDevice.quantity * this.getDeviceCostWithDiscount(requestDevice);
    }

    changeDevicesDiscountLevel(rate: number) {
        if (rate != null) {
            this.requestDevicesList.forEach(x => {
                let maxDiscount = this.calculateMaxDeviceDiscountLimit(x, true);
                x.discount = maxDiscount * rate;
            });
        }
        else {
            this.requestDevicesList.forEach(x => x.discount = x.discountPrimary);
        }
    }

    commitDevicesDiscountLevel(rate: number) {
        let requestDeviceItems: SetRequestDevicesDiscountItem[] = [];

        this.requestDevicesList.forEach(requestDevice => {
            requestDevice.requestDeviceIds.forEach(requestDeviceId => {
                let item = {
                    requestDeviceId: requestDeviceId,
                    discount: Math.floor(requestDevice.discount)
                } as SetRequestDevicesDiscountItem;
                requestDeviceItems.push(item);
            });
        });

        let setDiscountModel = {
            requestDevices: requestDeviceItems
        } as SetRequestDevicesDiscount;

        this.loadingDevices = true;
        this.discountLevelsService.setRequestDevicesDiscount(setDiscountModel).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    calculateMaxDeviceDiscountLimit(requestDevice: NewRequestDevice | CustomerObjectDeviceDto, forDiscountLevel: boolean = false): number {
        if (this.roleForceDiscount) {
            if (forDiscountLevel) {
                this.maxDiscountLimit = this.deviceTypeFullItems.find(x => x.deviceTypeId == requestDevice.deviceTypeId).discountLimit;
            }
            else {
                this.maxDiscountLimit = 100;
            }
        }
        else if (requestDevice.deviceTypeId != null) {
            let deviceTypeDiscountLimit = this.deviceTypeFullItems.find(x => x.deviceTypeId == requestDevice.deviceTypeId).discountLimit;
            this.maxDiscountLimit = this.roleDiscountLimit > deviceTypeDiscountLimit
                ? deviceTypeDiscountLimit
                : this.roleDiscountLimit;
        }
        else {
            this.maxDiscountLimit = 0;
        }

        return this.maxDiscountLimit;
    }

    getDeviceCostWithDiscount(requestDevice: NewRequestDevice): number {
        if (requestDevice.fullCost && requestDevice.discount) {
            let cost = requestDevice.fullCost - (requestDevice.fullCost * requestDevice.discount / 100);
            return Number.isInteger(cost) ? cost : Math.floor(cost);
        }

        return requestDevice.fullCost;
    }

    deviceDiscountChange(dataItem: NewRequestDevice) {
        if (this.deviceDiscountInvalid(dataItem) && dataItem.discount > 0) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.maxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
        }
    }

    deviceDiscountInvalid(requestDevice: NewRequestDevice): boolean {
        return requestDevice.discount != null &&
            (requestDevice.discount < 0 ||
                requestDevice.discount > 100 ||
                requestDevice.discount > this.maxDiscountLimit);
    }

    getAvailableInCentralWarehouses(requestDevice: NewRequestDevice): boolean {
        return requestDevice.availableInCentralWarehouses;
    }

    getIsCompletelyAvailable(requestDevice: NewRequestDevice): boolean | null {
        return requestDevice.isCompletelyAvailable;
    }

    isDeviceInstalled(device: NewRequestDevice): boolean {
        return device != null && device.reserveResultId == <number>ReserveResult.installedOnTsp;
    }

    editCustomerObjectDevice = (): CustomerObjectDeviceDto => {
        return new CustomerObjectDeviceDto();
    }

    saveCustomerObjectDevice({ dataItem }) {
        this.loadingDevices = true;
        this.devicesService.update(dataItem, null, true, true).subscribe(() => {
            this.customerObjectsService.getRequestCustomerObjectDevices(this.requestId).subscribe((resp) => {
                this.applyCustomerObjectDevices(resp);
                this.loadingDevices = false;
            }, () => { this.loadingDevices = false; });
        });
    }

    refreshDeviceDropdowns() {
        this.dropDownDeviceModels = this.deviceModels;
        this.dropDownDeviceSuppliers = this.deviceSuppliers;
    }

    refreshDevicesStatus() {
        this.loadingDevices = true;
        this.cachesService.refreshRequestEngineerCache(this.requestId).subscribe(() => {
            this.loadRequestDevices();
        });
    }

    createNewRequestService = (): NewRequestService => {
        var requestService = new NewRequestService();
        requestService.requestId = this.requestId;
        requestService.isDefault = true;
        return requestService;
    }

    saveRequestServiceHandler({ dataItem }: any) {
        this.loadingServices = true;
        let requestServiceIds = dataItem.requestServiceIds.filter(x => x != 0);
        const requests$ = [];

        if (dataItem.count < requestServiceIds.length) {
            const removeCount = requestServiceIds.length - dataItem.count;
            const idsToRemove = requestServiceIds.sort((a, b) => b - a).slice(0, removeCount);
            requestServiceIds = requestServiceIds.filter(x => !idsToRemove.includes(x));
            const removes$ = idsToRemove.map(requestServiceId =>
                this.requestServicesService.remove(requestServiceId.toString(), null, null, true));
            requests$.push(...removes$);
        }

        if (dataItem.count > requestServiceIds.length) {
            const createCount = dataItem.count - requestServiceIds.length;
            const creates$ = Array.from({ length: createCount }, (_, i) => i).map(_ =>
                this.requestServicesService.create({
                    ...dataItem,
                    requestId: this.requestId,
                    requestServiceId: 0,
                }, null));
            requests$.push(...creates$);
        }

        if (requestServiceIds.length > 0) {
            const updates$ = requestServiceIds.map(requestServiceId =>
                this.requestServicesService.update({
                    ...dataItem,
                    requestServiceId: requestServiceId,
                }, null));
            requests$.push(...updates$);
        }

        forkJoin(requests$).subscribe(() => {
            this.loadRequestServices();
        });
    }

    cellClickRequestServiceHandler({ dataItem, sender, rowIndex, isEdited, column, originalEvent }) {
        if (!this.canEditRequest || isEdited) {
            return;
        }
        if (sender.isRowEdited && sender.isRowEdited(rowIndex)) {
            return;
        }
        if (column && column.field === 'isDone') {
            return;
        }
        if (originalEvent && originalEvent.target && originalEvent.target.closest
            && originalEvent.target.closest('.sad-acts-wrap')) {
            return;
        }

        this.editRequestServiceHandler({ dataItem, sender, rowIndex });
    }

    editRequestServiceHandler({ dataItem, sender, rowIndex }: any) {
        this.calculateMaxServiceDiscountLimit(dataItem);
        sender.editRow(rowIndex);
    }

    removeRequestServiceHandler({ dataItem }: any) {
        this.loadingServices = true;
        const requestServiceIds = dataItem.requestServiceIds.filter(x => x != 0);
        const removes$ = requestServiceIds.map(requestServiceId =>
            this.requestServicesService.remove(requestServiceId.toString(), null, null, true));
        forkJoin(removes$).subscribe(() => {
            this.loadRequestServices();
        });
    }

    addNewRequestService() {
        const dialogRef = this.dialogService.open({
            content: ServicesHierarchicalSelectorComponent,
            title: 'Добавление услуг',
            width: '80%',
            height: '820px',
            minWidth: '800px'
        });
        const serviceSelector = <ServicesHierarchicalSelectorComponent>dialogRef.content.instance;

        serviceSelector.height = 460;
        serviceSelector.defaultRequestTypeId = this.requestTypeId;
        serviceSelector.defaultRequestCategoryId = this.requestCategoryId;
        serviceSelector.existingServices = this.requestServices;
        serviceSelector.requestId = this.requestId;
        serviceSelector.showAddAsAdditional = true;
        serviceSelector.addAsAdditional = false;
        serviceSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        serviceSelector.onContinue.subscribe((services: NewRequestService[]) => {
            const isDefault = !serviceSelector.addAsAdditional;
            dialogRef.close();
            this.loadingServices = true;

            const result: NewRequestService[] = [];
            for (const service of services) {
                for (let i = 0; i < service.count; i++) {
                    result.push({ ...service, count: 1 });
                }
            }

            let multipleCreateModel = {
                requestId: this.requestId,
                items: result.map(service => {
                    return {
                        serviceId: service.serviceId,
                        isDefault: isDefault,
                        cost: service.cost
                    } as MultipleRequestServiceItem;
                })
            } as MultipleRequestServices;

            this.requestServicesService.createMultiple(multipleCreateModel).subscribe(() => {
                this.loadRequestServices();
            });
        });
    }

    serviceChange(dataItem: NewRequestService) {
        this.calculateMaxServiceDiscountLimit(dataItem);
    }

    calculateMaxServiceDiscountLimit(requestService: NewRequestService, forDiscountLevel: boolean = false): number {
        if (this.roleForceDiscount) {
            if (forDiscountLevel) {
                this.maxDiscountLimit = this.fullService.find(x => x.id == requestService.serviceId).discountLimit;
            }
            else {
                this.maxDiscountLimit = 100;
            }
        }
        else if (requestService.serviceId != null) {
            let serviceDiscountLimit = this.fullService.find(x => x.id == requestService.serviceId).discountLimit;
            this.maxDiscountLimit = this.roleDiscountLimit > serviceDiscountLimit
                ? serviceDiscountLimit
                : this.roleDiscountLimit;
        }
        else {
            this.maxDiscountLimit = 0;
        }

        return this.maxDiscountLimit;
    }

    getServiceSum(requestService: NewRequestService): number {
        return requestService.count * this.getServiceCostWithDiscount(requestService);
    }

    getServiceCostWithDiscount(requestService: NewRequestService): number {
        if (requestService.fullCost && requestService.discount) {
            let cost = requestService.fullCost - (requestService.fullCost * requestService.discount / 100);
            return Number.isInteger(cost) ? cost : Math.floor(cost);
        }

        return requestService.fullCost;
    }

    serviceDiscountChange(dataItem: NewRequestService) {
        if (this.serviceDiscountInvalid(dataItem) && dataItem.discount > 0) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.maxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
        }
    }

    serviceDiscountInvalid(requestService: NewRequestService): boolean {
        return requestService.discount != null &&
            (requestService.discount < 0 ||
                requestService.discount > 100 ||
                requestService.discount > this.maxDiscountLimit);
    }

    changeServicesDiscountLevel(rate: number) {
        if (rate != null) {
            this.requestServices.forEach(x => {
                let maxDiscount = this.calculateMaxServiceDiscountLimit(x, true);
                x.discount = maxDiscount * rate;
            });
        }
        else {
            this.requestServices.forEach(requestService => requestService.discount = requestService.discountPrimary);
        }
    }

    commitServicesDiscountLevel(rate: number) {
        let requestServiceItems: SetRequestServicesDiscountItem[] = [];

        this.requestServices.forEach(requestService => {
            requestService.requestServiceIds.forEach(requestServiceId => {
                let item = {
                    requestServiceId: requestServiceId,
                    discount: Math.floor(requestService.discount)
                } as SetRequestServicesDiscountItem;
                requestServiceItems.push(item);
            });
        });

        let setDiscountModel = {
            requestServices: requestServiceItems
        } as SetRequestServicesDiscount;

        this.loadingServices = true;
        this.discountLevelsService.setRequestServicesDiscount(setDiscountModel).subscribe(() => {
            this.loadRequestServices();
        });
    }

    canSaveRequestService(dataItem: NewRequestService): boolean {
        if (dataItem.isDefault) {
            return dataItem.serviceId && !this.serviceDiscountInvalid(dataItem);
        }

        return dataItem.serviceId && !this.serviceDiscountInvalid(dataItem) && (dataItem.cost == null || dataItem.cost > 0) && dataItem.count >= 1;
    }

    toggleServiceDone(dataItem: NewRequestService, event: Event, persist: boolean = true) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (!this.canEditRequest || !this.isAdmin || this.loadingServices) {
            return;
        }

        dataItem.isDone = !dataItem.isDone;

        if (!persist) {
            return;
        }

        const requestServiceIds = (dataItem.requestServiceIds || []).filter(x => x != 0);
        if (requestServiceIds.length === 0) {
            return;
        }

        const updates$ = requestServiceIds.map(requestServiceId =>
            this.requestServicesService.update({
                ...dataItem,
                requestServiceId: requestServiceId,
            }, null));

        forkJoin(updates$).subscribe(
            () => {},
            () => { dataItem.isDone = !dataItem.isDone; }
        );
    }

    formatObjectDeviceDate(value: Date): string {
        if (!value) {
            return '—';
        }

        const date = value instanceof Date ? value : new Date(value);
        if (isNaN(date.getTime())) {
            return '—';
        }

        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    }

    get isReclamation(): boolean {
        return this.requestTypeId == <number>RequestType.reclamation;
    }

    get isService(): boolean {
        return this.requestTypeId == <number>RequestType.service;
    }

    get isInstallRequest(): boolean {
        return this.requestTypeId == <number>RequestType.install
            || this.requestTypeId == <number>RequestType.freeInstallation
            || this.requestTypeId == <number>RequestType.saleInstallation
            || this.requestTypeId == <number>RequestType.remoteInstall
            || this.requestTypeId == <number>RequestType.installWithDismantle;
    }

    get showObjectDeviceSelection(): boolean {
        return this.isService || this.isInstallRequest;
    }

    get showInstalledDeviceAction(): boolean {
        return this.isService;
    }

    get objectDeviceActionName(): string {
        return 'На ремонт';
    }

    get objectDeviceSelectionTitle(): string {
        return this.isInstallRequest ? 'На монтаж' : 'Ремонт по оборудованию';
    }

    get addAsAdditionalByDefault(): boolean {
        return this.appService.isMobileDevice;
    }

    get isWarrantyRequest(): boolean {
        return this.warrantyRequestTypes.some(x => x == this.requestTypeId);
    }

    get hasDiscountRight(): boolean {
        return this.securityService.hasClaim('role-Discounting-right');
    }

    get isAdmin(): boolean {
        return this.securityService.isAdmin();
    }

    get isOnlinePayment(): boolean {
        return this.paymentTypeId == <number>PaymentTypeEnum.online;
    }

    devicePayment(device: NewRequestDevice): { text: string, css: string, color: string } {
        const ids = device.requestDeviceIds && device.requestDeviceIds.length
            ? device.requestDeviceIds
            : [device.requestDeviceId];
        return this.paymentTag(!!device.isPrepaid, ids, this.paidDeviceIds);
    }

    servicePayment(service: NewRequestService): { text: string, css: string, color: string } {
        const ids = service.requestServiceIds && service.requestServiceIds.length
            ? service.requestServiceIds
            : [service.requestServiceId];
        return this.paymentTag(!!service.isPrepaidService, ids, this.paidServiceIds);
    }

    private loadLinePayments(): void {
        if (!this.isOnlinePayment || !this.requestId) {
            return;
        }

        this.paymentsService.getRequestPayments(this.requestId).subscribe(payments => {
            this.paidDeviceIds = this.collectPaidIds(payments, 'device');
            this.paidServiceIds = this.collectPaidIds(payments, 'service');
        });
    }

    private collectPaidIds(payments: RequestPaymentItem[], type: 'device' | 'service'): Set<number> {
        const ids = new Set<number>();
        (payments || []).forEach(payment => {
            (payment.positions || []).forEach(position => {
                const payed = position && (position.payed === true || <any>position.payed === 1);
                if (!payed) {
                    return;
                }
                if (type == 'service' && position.requestServiceId) {
                    ids.add(position.requestServiceId);
                }
                if (type == 'device' && position.requestDeviceId) {
                    ids.add(position.requestDeviceId);
                }
            });
        });
        return ids;
    }

    private paymentTag(prepaid: boolean, ids: number[], paidIds: Set<number>): { text: string, css: string, color: string } {
        if (prepaid) {
            return { text: 'Предоплачена', css: 'sad-paid-prepaid', color: null };
        }

        if (this.isOnlinePayment) {
            const lineIds = (ids || []).filter(id => !!id);
            const paidCount = lineIds.filter(id => paidIds.has(id)).length;
            if (lineIds.length > 0 && paidCount == lineIds.length) {
                return { text: 'Оплачено', css: 'sad-paid-yes', color: null };
            }
            if (paidCount > 0) {
                return { text: 'Частично оплачен', css: 'sad-paid-partial', color: null };
            }
            return { text: 'Не оплачено', css: 'sad-paid-no', color: null };
        }

        return {
            text: this.paymentStatusName || '—',
            css: 'sad-paid-request',
            color: this.paymentStatusColor || null
        };
    }

    get addDevicesDisabled(): boolean {
        return (this.paymentStatusId != null && this.paymentStatusId != <number>PaymentStatusEnum.waitIssueInvoice)
            || this.loadingDevices;
    }

    get addServicesDisabled(): boolean {
        return (this.paymentStatusId != null && this.paymentStatusId != <number>PaymentStatusEnum.waitIssueInvoice)
            || this.loadingServices;
    }

    get customerRequestDevices(): NewRequestDevice[] {
        return (this.allRequestDevices || []).filter(item => item.customerDevice);
    }

    get visibleCustomerObjectDevices(): CustomerObjectDeviceDto[] {
        // Свежедобавленное через заявку оборудование клиента уже есть в customerRequestDevices.
        // Строка объекта без монтажа/СО/СН — дубль той же единицы (1→2, 2→4).
        const freshDeviceIds = new Set(
            this.customerRequestDevices
                .filter(device => device.deviceId != null)
                .map(device => device.deviceId)
        );

        return (this.customerObjectDevices || []).filter(device => {
            if (device.deviceId == null || !freshDeviceIds.has(device.deviceId)) {
                return true;
            }

            return !!device.installationDate || !!device.lastServiceDate || !!device.serialNumber;
        });
    }

    get objectDevicesTotalCount(): number {
        return this.visibleCustomerObjectDevices.length + this.customerRequestDevices.length;
    }

    startEditCustomerDevice(device: NewRequestDevice) {
        if (!this.canEditRequest || !device) {
            return;
        }
        this.editingCustomerDeviceId = device.requestDeviceId;
        this.editingCustomerSerial = device.serialNumber || '';
    }

    cancelEditCustomerDevice() {
        this.editingCustomerDeviceId = null;
        this.editingCustomerSerial = '';
    }

    saveCustomerDeviceSerial(device: NewRequestDevice) {
        if (!device || this.loadingDevices) {
            return;
        }
        this.loadingDevices = true;
        this.requestDevicesService.update({
            ...device,
            serialNumber: this.editingCustomerSerial
        }, null).subscribe(() => {
            this.cancelEditCustomerDevice();
            this.loadRequestDevices();
        }, () => this.loadingDevices = false);
    }

    deleteCustomerRequestDevice(device: NewRequestDevice) {
        if (!this.canEditRequest || !device || this.loadingDevices) {
            return;
        }
        this.loadingDevices = true;
        this.requestDevicesService.remove(device.requestDeviceId.toString(), null, null, true).subscribe(() => {
            this.loadRequestDevices();
        }, () => this.loadingDevices = false);
    }

    get requestDevicesList(): NewRequestDevice[] {
        return (this.mainRequestDevices || []).concat(this.additionalRequestDevices || []);
    }

    get selectedObjectDevices(): CustomerObjectDeviceDto[] {
        return (this.customerObjectDevices || []).filter(x => x.existInRequestDevices);
    }

    get pinnedObjectDevices(): { deviceModelName: string, serialNumber: string, installationDate: Date, lastServiceDate: Date }[] {
        if (this.isInstallRequest) {
            return this.customerRequestDevices.map(device => ({
                deviceModelName: device.deviceModelName,
                serialNumber: device.serialNumber,
                installationDate: null,
                lastServiceDate: null
            }));
        }

        return this.selectedObjectDevices;
    }

    objectDevicesCountWord(count: number): string {
        const n = Math.abs(count) % 100;
        const n1 = n % 10;
        if (n > 10 && n < 20) {
            return 'единиц';
        }
        if (n1 == 1) {
            return 'единица';
        }
        if (n1 > 1 && n1 < 5) {
            return 'единицы';
        }
        return 'единиц';
    }

    toggleObjectDeviceSelection(device: CustomerObjectDeviceDto) {
        if (!this.canEditRequest || this.loadingDevices || !device || !this.showObjectDeviceSelection) {
            return;
        }

        this.loadingDevices = true;

        if (device.existInRequestDevices) {
            this.requestDevicesService.deleteFromDevice(this.requestId, device.deviceId).subscribe(() => {
                this.loadRequestDevices();
                this.refreshRequest();
            }, () => {
                this.loadingDevices = false;
            });
            return;
        }

        this.requestDevicesService.createFromDevice(this.requestId, device.deviceId).subscribe(() => {
            this.loadRequestDevices();
            this.refreshRequest();
        }, () => {
            this.loadingDevices = false;
        });
    }

    private autoFitGrids() {
        const fixedTitles = ['Цена за ед.', 'Скидка', 'Кост-центр', 'Оплата', 'Выполнена', 'Установлено', 'Наличие', 'Наименование'];
        setTimeout(() => {
            this.fitGridColumns(this.requestDevicesGrid, fixedTitles);
            this.fitGridColumns(this.requestServicesGrid, fixedTitles);
            setTimeout(() => {
                this.lockGridColumnWidths(this.requestDevicesGrid);
                this.lockGridColumnWidths(this.requestServicesGrid);
            });
        });
    }

    private fitGridColumns(grid: GridComponent, fixedTitles: string[]) {
        if (!grid) {
            return;
        }

        const columns = grid.columns.toArray()
            .filter((column: any) => fixedTitles.indexOf(column.title) < 0);
        grid.autoFitColumns(columns);
    }

    private lockGridColumnWidths(grid: GridComponent) {
        if (!grid || !grid.wrapper) {
            return;
        }

        const flagWidths = {
            'Выполнена': 170,
            'Установлено': 140,
            'Наличие': 136
        };
        const columns = grid.columns.toArray();
        columns.forEach((column: any) => {
            if (flagWidths[column.title]) {
                column.width = flagWidths[column.title];
            }
        });

        const nameColumn: any = columns.find((column: any) => column.title === 'Наименование');
        const gridWidth = grid.wrapper.nativeElement.clientWidth;
        if (!nameColumn || gridWidth < 200) {
            return;
        }

        const used = columns
            .filter((column: any) => column !== nameColumn)
            .reduce((sum, column: any) => sum + (Number(column.width) || 0), 0);
        nameColumn.width = Math.max(180, gridWidth - used);
    }

    get totalDevicesPrice(): number {
        const sumOnlyInstalled = this.additionalRequestDevices.some(x => x.reserveResultId == <number>ReserveResult.installedOnTsp) ||
            this.mainRequestDevices.some(x => x.reserveResultId == <number>ReserveResult.installedOnTsp);

        let mainRequestDevicesFiltered = sumOnlyInstalled
            ? this.mainRequestDevices.filter(x => x.reserveResultId == <number>ReserveResult.installedOnTsp)
            : this.mainRequestDevices;

        let additionalRequestDevicesFiltered = sumOnlyInstalled
            ? this.additionalRequestDevices.filter(x => x.reserveResultId == <number>ReserveResult.installedOnTsp)
            : this.additionalRequestDevices;

        const mainTotalPrice = mainRequestDevicesFiltered.reduce((sum, item) => sum + (this.getDeviceCostWithDiscount(item) * item.quantity), 0);
        const additionalTotalPrice = additionalRequestDevicesFiltered.reduce((sum, item) => sum + (this.getDeviceCostWithDiscount(item) * item.quantity), 0);

        return Math.floor(mainTotalPrice + additionalTotalPrice);
    }

    get totalServicesPrice(): number {
        if (this.isServiceAgreement && this.agreementServices) {
            return this.agreementServices.totalPrice;
        }

        const priceServices = this.requestServices.some(x => x.isDone)
            ? this.requestServices.filter(x => x.isDone)
            : this.requestServices;

        const totalPrice = priceServices.reduce((sum, item) => sum + (this.getServiceCostWithDiscount(item) * item.count), 0);

        return Math.floor(totalPrice);
    }

    get totalRequestPrice(): number {
        return (this.showDevices ? this.totalDevicesPrice : 0) + (this.showServices ? this.totalServicesPrice : 0);
    }
}
